import { useTranslation } from "react-i18next";
import { Truck } from "lucide-react";
import { formatCurrency } from "@/lib/product";

/** Verzendkosten in het besteloverzicht, met voortgang naar gratis verzending. */
export const ShippingSummary = ({ verzending, testId = "shipping-summary", toonToelichting = true }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  if (!verzending) return null;
  return (
    <div className="space-y-1" data-testid={testId}>
      <div className="flex items-baseline justify-between">
        <span className="flex items-center gap-2 text-muted-foreground">
          <Truck className="h-4 w-4" aria-hidden="true" />
          {t("shipping.costs")}
        </span>
        <span className="font-medium tabular-nums" data-testid={`${testId}-amount`}>
          {verzending.gratis ? t("shipping.free") : formatCurrency(verzending.kosten, lang)}
        </span>
      </div>
      {verzending.gratisVanaf && !verzending.gratis && (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-free-progress`}>
          {t("shipping.freeRemaining", {
            ontbreekt: formatCurrency(verzending.tekortVoorGratis, lang),
            vanaf: formatCurrency(verzending.gratisVanaf, lang),
          })}
        </p>
      )}
      {verzending.gratisVanaf && verzending.gratis && (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-free-reached`}>
          {t("shipping.freeReached", { vanaf: formatCurrency(verzending.gratisVanaf, lang) })}
        </p>
      )}
      {toonToelichting && <p className="text-xs text-muted-foreground">{t("shipping.note")}</p>}
    </div>
  );
};
